/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Job } from 'src/types/processing-schemas';

interface ActionCancelJobProps {
  job: Job;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  className?: string;
  handleCancelJob?: () => Promise<Job>;
}
export const ActionCancelJob: React.FC<ActionCancelJobProps> = ({ job, visible, setVisible, handleCancelJob }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      visible={visible}
      resizable={false}
      draggable={false}
      style={{ width: '22vw' }}
      onHide={() => {
        if (!visible) {
          return;
        }
        setVisible(false);
      }}
    >
      <div className="flex flex-column align-items-center w-full">
        <div>
          <i className="pi pi-exclamation-circle text-7xl text-red-600" />
        </div>
        <div className="text-center">
          <pre className="p-0">{job.jobID}</pre>
          <p> {t(['jobs.actions.alert_cancel', 'Do you want to stop the job execution ?'])} </p>
        </div>
        <div className="w-full mt-4">
          <div className="flex align-items-center justify-content-end">
            <Button
              size="small"
              severity="secondary"
              className="text-xs mx-2"
              onClick={() => {
                setVisible(false);
              }}
              label={t(['jobs.actions.no_keep', 'No'])}
            />
            <Button
              size="small"
              severity="danger"
              className="text-xs"
              onClick={() => {
                handleCancelJob();
              }}
              label={t(['jobs.actions.yes_stop', 'Yes'])}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
